import React, { useEffect, useRef, useState } from "react";
import {
  MdSubscriptions,
  MdKeyboardArrowDown,
  MdOutlineWbTwilight,
  MdOutlineNightlightRound,
} from "react-icons/md";
import { IoSettings } from "react-icons/io5";
import { ImBrightnessContrast } from "react-icons/im";
import { IoMdMenu } from "react-icons/io";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { RiProjectorFill } from "react-icons/ri";
import { FaPlus } from "react-icons/fa6";
import { FiMoreVertical } from "react-icons/fi";
import { FaPlusCircle } from "react-icons/fa";
import { GoProjectSymlink } from "react-icons/go";
import { IoMdCloseCircle } from "react-icons/io";
import themeClasses from "../themeClasses";

export default function MbLeftBar({
  chats,
  activeChatId,
  onSelectChat,
  onNewChat,
  onDeleteChat,
  onEditChat,
  onToggleSubscription,
  onChangeTheme,
  currentTheme,
  onSidebarToggle,
  projects,
  onAddProject,
  onDeleteProject,
  onEditProject,
  onEditSubproject,
  onAddSubproject,
  onDeleteSubproject,
  activeProjectChatId,
}) {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const [showThemeMenu, setShowThemeMenu] = useState(false);

  const [showProjectModal, setShowProjectModal] = useState(false);
  const [newProjectName, setNewProjectName] = useState("");

  const [openChatMenu, setOpenChatMenu] = useState(null);
  const [editingChatId, setEditingChatId] = useState(null);
  const [editingChatName, setEditingChatName] = useState("");

  const [openProjectMenu, setOpenProjectMenu] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const projectMenuRef = useRef(null);
  const subMenuRef = useRef(null);
  const chatMenuRef = useRef(null);

  const [showSubprojectModal, setShowSubprojectModal] = useState(false);
  const [subprojectName, setSubprojectName] = useState("");
  const [currentProjectId, setCurrentProjectId] = useState(null);

  const [editingProjectId, setEditingProjectId] = useState(null);
  const [editingSubId, setEditingSubId] = useState(null);
  const [editText, setEditText] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        projectMenuRef.current &&
        !projectMenuRef.current.contains(event.target)
      ) {
        setOpenProjectMenu(null);
      }

      if (subMenuRef.current && !subMenuRef.current.contains(event.target)) {
        setOpenSubMenu(null);
      }

      if (chatMenuRef.current && !chatMenuRef.current.contains(event.target)) {
        setOpenChatMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSidebarToggle = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState);
    setShowSettingsMenu(false);
    setShowThemeMenu(false);
    onSidebarToggle && onSidebarToggle(newState);
  };

  const handleSettingsClick = () => {
    setShowSettingsMenu(!showSettingsMenu);
    if (!showSettingsMenu) setShowThemeMenu(false);
  };

  const handleChatEditSave = (chatId) => {
    if (editingChatName.trim()) {
      onEditChat && onEditChat(chatId, editingChatName.trim());
    }
    setEditingChatId(null);
    setEditingChatName("");
  };

  const handleAddProjectClick = () => {
    if (!newProjectName.trim()) return;
    onAddProject(newProjectName.trim());
    setNewProjectName("");
    setShowProjectModal(false);
  };

  const isFirefox = navigator.userAgent.toLowerCase().includes("firefox");
  const logoSrc = themeClasses[currentTheme].logo;

  return (
    <div
      className={`mb-leftbar ${
        themeClasses[currentTheme].leftbar
      }  transition-width-[0.3s] duration-300 h-[100vh] pt-10 pb-16 ${
        isCollapsed ? "w-[60px]" : "w-[250px]"
      }`}
    >
      <div
        className={`${
          themeClasses[currentTheme].body
        } mb-leftbar-top flex items-center gap-2.5 px-4 py-2.5 border-b border-gray-800 fixed left-0 top-0 z-50 transition-all duration-300 ${
          isCollapsed ? "w-[60px]" : "w-[248px]"
        }`}
      >
        <IoMdMenu
          onClick={handleSidebarToggle}
          className={`cursor-pointer transition-all duration-300 ${
            isCollapsed ? "text-[25px]" : "text-[22px]"
          }`}
        />
        {!isCollapsed && (
          <img
            src={logoSrc}
            alt="Logo"
            className="mb-leftbar-logo h-8 w-auto m-auto"
          />
        )}
      </div>

      <div className="left-bar-mid-info h-full overflow-x-hidden overflow-y-auto">
        <div
          className={`left-nav-items transition-all duration-300 ${
            isCollapsed ? "p-4" : "p-3"
          }`}
        >
          <ul>
            <li className="flex gap-1 py-3 " onClick={onNewChat}>
              <div className="new-chat itemIcon flex">
                <FaPlus size={20} />
              </div>
              {!isCollapsed && <span className="new-chat-btn">New Chat</span>}
              {isCollapsed && (
                <Tooltip
                  anchorSelect=".new-chat"
                  place="right"
                  className=" z-[999]"
                >
                  New Chat
                </Tooltip>
              )}
            </li>

            <li className="flex gap-1 py-2" onClick={onToggleSubscription}>
              <div className="view-subscriptions itemIcon flex">
                <MdSubscriptions size={20} />
              </div>
              {!isCollapsed && <span>View Subscriptions</span>}
              {isCollapsed && (
                <Tooltip
                  anchorSelect=".view-subscriptions"
                  place="right"
                  className=" z-[999]"
                >
                  View Subscriptions
                </Tooltip>
              )}
            </li>

            <li className="py-2" onClick={handleSettingsClick}>
              <div className="flex gap-2 py-1">
                <div className="settings-help itemIcon flex">
                  <IoSettings size={20} />
                </div>
                {!isCollapsed && <span>Settings & Help</span>}
                {!isCollapsed && (
                  <MdKeyboardArrowDown
                    className={`ml-auto cursor-pointer transition-transform duration-300 ${
                      showSettingsMenu ? "rotate-180" : "rotate-0"
                    }`}
                  />
                )}
                {isCollapsed && (
                  <Tooltip
                    anchorSelect=".settings-help"
                    place="right"
                    className=" z-[999]"
                  >
                    Settings & Help
                  </Tooltip>
                )}
              </div>

              {showSettingsMenu && !isCollapsed && (
                <ul className="p-4 pb-0">
                  <li className="flex gap-2 items-center">
                    <div
                      className="ms-themes itemIcon flex"
                      onClick={() => setShowThemeMenu(!showThemeMenu)}
                    >
                      <ImBrightnessContrast size={18} />
                    </div>
                    <span>Themes</span>
                  </li>
                  <ul className="p-2 pl-4">
                    <li
                      className="flex gap-2 py-2"
                      onClick={() => onChangeTheme("light")}
                    >
                      <div className="theme-light itemIcon flex">
                        <MdOutlineWbTwilight size={18} />
                      </div>
                      <span>Light</span>
                    </li>
                    <li
                      className="flex gap-2"
                      onClick={() => onChangeTheme("dark")}
                    >
                      <div className="theme-dark itemIcon flex">
                        <MdOutlineNightlightRound size={18} />
                      </div>
                      <span>Dark</span>
                    </li>
                  </ul>
                </ul>
              )}
            </li>
          </ul>

          <div className="projects-section">
            <ul className="pb-3">
              <li
                className="flex gap-2 py-2 cursor-pointer "
                onClick={() => setShowProjectModal(true)}
              >
                <div className="mb-projects itemIcon flex">
                  <RiProjectorFill size={20} />
                </div>
                {!isCollapsed && <span>New Project</span>}
                {isCollapsed && (
                  <Tooltip
                    anchorSelect=".mb-projects"
                    place="right"
                    className=" z-[999]"
                  >
                    New Project
                  </Tooltip>
                )}
              </li>

              {!isCollapsed &&
                projects.map((project) => {
                  const subprojects = project.subprojects || [];
                  const isActiveProject =
                    project.chat.id === activeProjectChatId ||
                    subprojects.some((s) => s.chat.id === activeProjectChatId);

                  return (
                    <li key={project.id} className="subProjectItem pb-0">
                      <div
                        className={`font-semibold ${
                          isActiveProject ? "bg-gray-200 rounded" : ""
                        } p-2 pr-0 pb-0 cursor-pointer`}
                        onClick={() => {
                          if (!subprojects.length)
                            onSelectChat(project.chat.id, true);
                        }}
                      >
                        {editingProjectId === project.id && (
                          <input
                            autoFocus
                            value={editText}
                            onChange={(e) => setEditText(e.target.value)}
                            onBlur={() => {
                              if (editText.trim())
                                onEditProject(project.id, editText.trim());
                              setEditingProjectId(null);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                if (editText.trim())
                                  onEditProject(project.id, editText.trim());
                                setEditingProjectId(null);
                              }
                            }}
                            className="w-full p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#5ed162]"
                          />
                        )}

                        <div className="flex justify-between items-center gap-2 relative">
                          <div className="flex items-center gap-2">
                            <GoProjectSymlink size={18} />
                            <span className="mainProjectTitle truncate w-[150px] capitalize">
                              {project.name}
                            </span>
                          </div>

                          <div className="flex items-center gap-1 relative w-[34px]">
                            <span
                              className="add-subproject cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                setCurrentProjectId(project.id);
                                setSubprojectName("");
                                setShowSubprojectModal(true);
                              }}
                            >
                              <FaPlusCircle size={14} />
                            </span>

                            <div className="relative">
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setOpenProjectMenu(
                                    openProjectMenu === project.id
                                      ? null
                                      : project.id
                                  );
                                  setOpenSubMenu(null);
                                }}
                                className="p-0 bg-transparent border-none cursor-pointer"
                              >
                                <FiMoreVertical
                                  p-0
                                  bg-transparent
                                  border-none
                                  cursor-pointer
                                  size={18}
                                />
                              </span>

                              {openProjectMenu === project.id && (
                                <ul
                                  ref={projectMenuRef}
                                  className="absolute text-sm top-6 right-0 text-white dark:text-black bg-gray-800 p-1 rounded z-50 shadow-lg w-[120px]"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <li
                                    className="p-1 cursor-pointer hover:bg-gray-700"
                                    onClick={() => {
                                      setEditingProjectId(project.id);
                                      setEditText(project.name);
                                      setOpenProjectMenu(null);
                                    }}
                                  >
                                    Rename Project
                                  </li>

                                  <li
                                    className="px-1 cursor-pointer hover:bg-gray-700"
                                    onClick={() => {
                                      onDeleteProject(project.id);
                                      setOpenProjectMenu(null);
                                    }}
                                  >
                                    Delete Project
                                  </li>
                                </ul>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {subprojects.length > 0 && (
                        <ul className="pl-5">
                          {subprojects.map((sub) => (
                            <li
                              key={sub.id}
                              onClick={() => onSelectChat(sub.chat.id, true)}
                              className="relative flex items-center justify-between py-1 px-0 rounded"
                            >
                              {editingSubId === sub.id ? (
                                <input
                                  autoFocus
                                  value={editText}
                                  onChange={(e) => setEditText(e.target.value)}
                                  onBlur={() => {
                                    if (editText.trim())
                                      onEditSubproject(
                                        project.id,
                                        sub.id,
                                        editText.trim()
                                      );
                                    setEditingSubId(null);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      if (editText.trim())
                                        onEditSubproject(
                                          project.id,
                                          sub.id,
                                          editText.trim()
                                        );
                                      setEditingSubId(null);
                                    }
                                  }}
                                  className="flex-1 p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#5ed162]"
                                />
                              ) : (
                                <span className="subInnerProName truncate w-[185px] capitalize">
                                  {sub.name || "Unnamed Subproject"}
                                </span>
                              )}

                              <div className="relative">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setOpenSubMenu(
                                      openSubMenu === sub.id ? null : sub.id
                                    );
                                    setOpenProjectMenu(null);
                                  }}
                                  className="p-0 bg-transparent border-none cursor-pointer"
                                >
                                  <FiMoreVertical size={16} />
                                </span>

                                {openSubMenu === sub.id && (
                                  <ul
                                    ref={subMenuRef}
                                    className="absolute text-sm top-6 right-0 text-white dark:text-black bg-gray-800 p-1 rounded z-50 shadow-lg w-[120px]"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <li
                                      className="p-1 cursor-pointer hover:bg-gray-700"
                                      onClick={() => {
                                        setEditingSubId(sub.id);
                                        setEditText(sub.name);
                                        setOpenSubMenu(null);
                                      }}
                                    >
                                      Rename Project
                                    </li>
                                    <li
                                      className="p-1 cursor-pointer hover:bg-gray-700"
                                      onClick={() => {
                                        onDeleteSubproject(project.id, sub.id);
                                        setOpenSubMenu(null);
                                      }}
                                    >
                                      Delete Project
                                    </li>
                                  </ul>
                                )}
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>

        <div className="chatsList p-2.5 pb-5">
          {!isCollapsed && <h4 className="font-bold m-0">Chats History</h4>}
          <ul>
            {chats.map((chat) => (
              <li
                key={chat.id}
                className={`chat-history-item ${
                  chat.id === activeChatId ? "active" : ""
                }`}
              >
                {!isCollapsed && (
                  <div className="flex items-center justify-between relative w-full">
                    {editingChatId === chat.id ? (
                      <input
                        type="text"
                        value={editingChatName}
                        onChange={(e) => setEditingChatName(e.target.value)}
                        onBlur={() => {
                          if (editingChatName.trim())
                            onEditChat(chat.id, editingChatName.trim());
                          setEditingChatId(null);
                          setEditingChatName("");
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") e.target.blur();
                        }}
                        autoFocus
                        className="flex-1 mr-1 p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#5ed162]"
                      />
                    ) : (
                      <span
                        className="truncate cursor-pointer capitalize"
                        onClick={() => onSelectChat(chat.id, false)}
                      >
                        {chat.name}
                      </span>
                    )}
                    <FiMoreVertical
                      size={16}
                      className="cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenChatMenu(
                          openChatMenu === chat.id ? null : chat.id
                        );
                      }}
                    />
                    {openChatMenu === chat.id && (
                      <ul
                        ref={chatMenuRef}
                        className="absolute text-sm top-6 right-0 text-white dark:text-black bg-gray-800 p-1 rounded z-50 shadow-lg w-[120px]"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <li
                          className="p-1 cursor-pointer hover:bg-gray-700"
                          onClick={() => {
                            setEditingChatId(chat.id);
                            setEditingChatName(chat.name);
                            setOpenChatMenu(null);
                          }}
                        >
                          Rename
                        </li>
                        <li
                          className="p-1 cursor-pointer hover:bg-gray-700"
                          onClick={() => {
                            onDeleteChat(chat.id);
                            setOpenChatMenu(null);
                          }}
                        >
                          Delete
                        </li>
                      </ul>
                    )}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div
        className={`mb-leftbar-bottom fixed bottom-0 left-0 flex items-center gap-2.5 p-2 border-t border-gray-800 text-sm transition-all duration-300 ${
          isCollapsed ? "w-60" : "w-[250px]"
        }`}
      >
        <div className="profileImg flex items-center">
          <img
            src="../images/pro-img.jpg"
            alt="profile-image"
            className={`rounded-full border border-gray-800 transition-all duration-300 ${
              isCollapsed ? "w-10 h-10" : "w-12 h-12"
            }`}
          />
        </div>

        {!isCollapsed && <div className="userName font-medium">User Name</div>}
      </div>

      {showProjectModal && (
        <div
          className={`fixed inset-0 flex items-center justify-center z-[10000] ${themeClasses[currentTheme].modalOverlay}`}
        >
          <div
            className={`p-5 rounded-lg w-72 text-center relative border-1 ${themeClasses[currentTheme].modalBox}`}
          >
            <span
              onClick={() => setShowProjectModal(false)}
              className={`absolute w-6 h-6 top-[-10px] right-[-10px] rounded-full flex items-center justify-center cursor-pointer ${themeClasses[currentTheme].modalCloseIcon}`}
            >
              <IoMdCloseCircle size={25} />
            </span>

            <h3 className="text-lg font-semibold mb-4">Add New Project</h3>

            <input
              type="text"
              placeholder="Enter project name"
              value={newProjectName}
              onChange={(e) => setNewProjectName(e.target.value)}
              className={`w-full p-2 rounded mb-4 border focus:outline-none focus:ring-2 focus:ring-[#5ed162] ${themeClasses[currentTheme].modalInput}`}
            />

            <div className="flex items-center justify-center">
              <button
                onClick={handleAddProjectClick}
                className="px-3 py-1 bg-[#4caf50] text-white rounded hover:bg-[#5ed162] transition"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}

      {showSubprojectModal && (
        <div
          className={`fixed inset-0 flex items-center justify-center z-[10000] ${themeClasses[currentTheme].modalOverlay}`}
        >
          <div
            className={`p-5 rounded-lg w-72 text-center relative border ${themeClasses[currentTheme].modalBox}`}
          >
            <span
              onClick={() => setShowSubprojectModal(false)}
              className={`absolute w-6 h-6 top-[-10px] right-[-10px] rounded-full flex items-center justify-center cursor-pointer ${themeClasses[currentTheme].modalCloseIcon}`}
            >
              <IoMdCloseCircle size={25} />
            </span>

            <h3 className="text-lg font-semibold mb-4">Add New Subproject</h3>

            <input
              type="text"
              placeholder="Enter subproject name"
              value={subprojectName}
              onChange={(e) => setSubprojectName(e.target.value)}
              className={`w-full p-2 rounded mb-4 border focus:outline-none focus:ring-2 focus:ring-[#5ed162] ${themeClasses[currentTheme].modalInput}`}
            />

            <div className="flex justify-center">
              <button
                onClick={() => {
                  if (subprojectName.trim()) {
                    onAddSubproject(currentProjectId, subprojectName.trim());
                    setShowSubprojectModal(false);
                  }
                }}
                className="px-3 py-1 text-white bg-[#4caf50] rounded hover:bg-[#5ed162] transition"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
